import React from 'react';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import './Styles/Banner.scss';

const Banner=()=>{
    return(
        <div className="about-banner">
            <h1 data-aos="zoom-in"
              data-aos-delay={100}>Join us to power what's next</h1>
            <p data-aos="zoom-in"
              data-aos-delay={200}>Collaborate and innovate with passionate people to build mind-blowing products</p>
            <StyledButton btn="See Current Jobs" />
            <div data-aos="fade-up"
              data-aos-delay={300} className="img-part"></div>
        </div>
    )
};
export default Banner ;